import {
  SessionPayment,
  SessionPaymentTransaction,
} from '@arc/unified-payments-frontend/shared-payment';
import { createAction, props, union } from '@ngrx/store';

export const sessionPaymentUpdated = createAction(
  '[Review Payment Component - Session] Session Payment Updated',
  props<{ response: SessionPayment }>(),
);

export const sessionPaymentTransactionsUpdated = createAction(
  '[Review Payment Component - Session] Session Payment Transactions Updated',
  props<{ payload: SessionPaymentTransaction[] }>(),
);

const PoiSessionReviewPaymentActions = union({
  sessionPaymentUpdated,
});

export type PoiSessionReviewPaymentActionsUnion =
  typeof PoiSessionReviewPaymentActions;
